function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './DateField.css';
import React, { useState, useRef, useEffect } from 'react';
import Flatpickr from 'react-flatpickr';
import { format } from 'date-fns';
// import "flatpickr/dist/themes/material_green.css";
import { IconDate } from '../../atoms/Icons/';
import { SitecoreContextReactContext } from '../../../utils/SitecoreContextReactContext';
import { get } from '../../../utils';
import { commonStyles as dateStyles } from '../../Listing/DateRange';
import { rtlStyles, ltrStyles, commonStyles } from '../accountAuthorizationStyles';
import { Arabic } from 'flatpickr/dist/l10n/ar.js';
import { Russian } from 'flatpickr/dist/l10n/ru.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';
import { Finnish } from 'flatpickr/dist/l10n/fi.js';
import { German } from 'flatpickr/dist/l10n/de.js';
import { Japanese } from 'flatpickr/dist/l10n/ja.js';
import { Norwegian } from 'flatpickr/dist/l10n/no.js';
import { Portuguese } from 'flatpickr/dist/l10n/pt.js';
import { Swedish } from 'flatpickr/dist/l10n/sv.js';
import { Mandarin } from 'flatpickr/dist/l10n/zh.js';
import { Danish } from 'flatpickr/dist/l10n/da.js';
import { French } from 'flatpickr/dist/l10n/fr.js';
import { Italian } from 'flatpickr/dist/l10n/it.js';
import { Korean } from 'flatpickr/dist/l10n/ko.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Romanian } from 'flatpickr/dist/l10n/ro.js';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { Ukrainian } from 'flatpickr/dist/l10n/uk.js';
import IconLock from '../../atoms/Icons/IconLock';
const formatInputDate = dateString => {
  if (dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  return dateString;
};
const DateField = props => {
  const {
    label,
    name = 'name',
    required = false,
    dateFormat = 'yyyy-mm-dd',
    updateContext,
    patternInvalidMessage = 'validateError',
    isValid = false,
    validate,
    value: contextValue,
    blurEvent,
    isOnlyFuture,
    isOnlyPast,
    tooltip,
    isTooltip,
    minDate,
    disabled = false
  } = props;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const [value, setValue] = useState('');
  const [highLightText, setHighLightText] = useState(false);
  const clickedTextRef = useRef(false);
  const currentLang = get(sitecoreContext, 'language');
  const currentLocale = lang => {
    if (lang === 'ar') {
      return Arabic;
    }
    if (lang === 'ru') {
      return Russian;
    }
    if (lang === 'cs') {
      return Czech;
    }
    if (lang === 'nl') {
      return Dutch;
    }
    if (lang === 'fi') {
      return Finnish;
    }
    if (lang === 'de') {
      return German;
    }
    if (lang === 'ja') {
      return Japanese;
    }
    if (lang === 'no') {
      return Norwegian;
    }
    if (lang === 'pt') {
      return Portuguese;
    }
    if (lang === 'sv') {
      return Swedish;
    }
    if (lang === 'zh') {
      return Mandarin;
    }
    if (lang === 'da') {
      return Danish;
    }
    if (lang === 'fr') {
      return French;
    }
    if (lang === 'it') {
      return Italian;
    }
    if (lang === 'ko') {
      return Korean;
    }
    if (lang === 'pl') {
      return Polish;
    }
    if (lang === 'ro') {
      return Romanian;
    }
    if (lang === 'es') {
      return Spanish;
    }
    if (lang === 'uk') {
      return Ukrainian;
    }
  };
  const onChangeEvent = value => {
    updateContext({
      [name]: _objectSpread(_objectSpread({}, props), {}, {
        valid: required && isValid,
        value,
        isChangeEvent: true
      })
    });
  };
  let flatPickerDateFormat = '';
  if (dateFormat.toLowerCase() === 'yyyy-mm-dd') {
    flatPickerDateFormat = 'yy-m-d';
  } else if (dateFormat.toLowerCase() === 'dd-mm-yyyy') {
    flatPickerDateFormat = 'd-m-yy';
  } else if (dateFormat.toLowerCase() === 'dd/mm/yyyy') {
    flatPickerDateFormat = 'd/m/yy';
  } else if (dateFormat.toLowerCase() === 'yyyy/mm/dd') {
    flatPickerDateFormat = 'yy/m/d';
  }
  const [state, setstate] = React.useState(contextValue);
  const [open, setOpen] = React.useState(false);
  const fp = /*#__PURE__*/React.createRef();
  useEffect(() => {
    document.body.addEventListener('click', () => {
      if (!clickedTextRef.current) {
        setHighLightText(false);
      }
      setOpen(false);
    });
    if (fp.current) {
      const flatPickerDiv = get(fp, 'current.flatpickr.calendarContainer');
      flatPickerDiv.addEventListener('click', e => {
        e.stopPropagation();
        // setOpen(false);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (contextValue && contextValue.length) {
      const currentDate = new Date(contextValue.replaceAll('-', '/'));
      if (isNaN(currentDate)) return;
      const validFormat = format(currentDate, 'yyyy-MM-dd');
      setstate(validFormat);
      updateContext({
        [name]: _objectSpread(_objectSpread({}, props), {}, {
          valid: required && !isValid,
          value: validFormat,
          isChangeEvent: false
        })
      });
    } else {
      setValue('');
      setstate('');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contextValue]);
  /* change format to flatpicker format as standard format not supported */
  const formatDate = (_ref, dateStr) => {
    let [date] = _ref;
    const selectedDate = new Date(Array.isArray(date) ? date[0] : date || dateStr);
    const day = selectedDate.getDate();
    const year = selectedDate.getFullYear();
    const month = selectedDate.getMonth() + 1;
    const ds = `${year}-${month}-${day}`;
    setOpen(false);
    setstate(ds);
    onChangeEvent(ds);
  };
  const handleTextMousedown = () => {
    clickedTextRef.current = true;
  };
  const handleTextFocus = () => {
    if (!clickedTextRef.current) {
      setHighLightText(true);
    }
  };
  const handleTextBlur = () => {
    clickedTextRef.current = false;
    if (blurEvent) blurEvent(state);
    if (!open) {
      setHighLightText(false);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: ` ${rtl ? rtlStyles : ltrStyles} ${commonStyles} ${rtl ? dateRtlStyles : dateLtrStyles} ${styles} ${dateStyles}  wiz__form-group 
       ${disabled ? 'field-disabled' : ''}`
  }, /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", {
    className: "accessibility-hidden-text"
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "date-field",
    onMouseDown: handleTextMousedown,
    onFocus: () => {
      handleTextFocus();
      // if (!disabled) {
      //   setOpen(true);
      // }
    },
    onBlur: handleTextBlur,
    onClick: () => {
      if (!disabled) {
        setOpen(true);
      }
    }
  }, /*#__PURE__*/React.createElement("input", {
    name: name,
    type: "text",
    className: `
				  flatpickr-input 
           form-input lr__field input-text-primary
            ${open ? 'form-input--filled' : ''}
            ${state ? 'form-input--filled' : ''}
            ${isValid ? 'form-input--error' : ''}
            
				`,
    value: formatInputDate(state),
    readOnly: true,
    placeholder: open ? 'DD/MM/YYYY' : ''
  }), label && /*#__PURE__*/React.createElement("label", {
    className: "form-label",
    htmlFor: name
  }, label, required ? /*#__PURE__*/React.createElement("strong", {
    className: "lr__red"
  }, "* ") : ''), /*#__PURE__*/React.createElement("div", {
    className: `${open ? '' : 'd-none'} datepicker`
  }, /*#__PURE__*/React.createElement(Flatpickr, {
    ref: fp,
    options: {
      dateFormat: flatPickerDateFormat,
      inline: true,
      locale: currentLang === 'en' ? 'en' : currentLocale(currentLang),
      minDate: isOnlyFuture ? 'today' : minDate,
      maxDate: isOnlyPast ? 'today' : undefined
    },
    "aria-label": label,
    value: state,
    onChange: formatDate
  })), /*#__PURE__*/React.createElement("span", {
    className: "date-field__icon"
  }, disabled ? /*#__PURE__*/React.createElement(IconLock, {
    className: "lock-icon"
  }) : /*#__PURE__*/React.createElement(IconDate, null))), isValid && /*#__PURE__*/React.createElement("section", null, /*#__PURE__*/React.createElement("p", {
    className: "lr__error"
  }, patternInvalidMessage))));
};
const styles = "swch2cx";
const dateLtrStyles = "dd562f1";
const dateRtlStyles = "d235w1w";
export default DateField;